import { FCard, FGrid, FGridItem } from "ferrum-design-system";
import { ConnectButton } from "../../components/WalletConnectorButton";
import { isMobile } from "react-device-detect";

export const SwapPageIntroCard = () => {
  return (
    <div className="intro-card">
      <FCard variant="multiswap-secondary">
        <FGrid className={"swap-intro-cards-no-margin"}>
          <FGridItem size={[7, 7, 12]} className="f-card-multiswap-primary-m">
            <div className="ms-intro-card-swap-heading-wrapper">
              <p className="ms-intro-card-swap-heading">WELCOME TO MULTISWAP</p>
              <p className="f-pt-1 ms-intro-card-swap-info-text">
                MultiSwap is a smart routing multichain DEX aggregator that
                enables crosschain swaps.
              </p>
              <p className="f-pt-1 ms-intro-card-swap-info-text">
                Seamlessly swap ANY ASSET for ANY ASSET on ANY NETWORK to ANY
                WALLET with MultiSwap!
              </p>
              <ConnectButton
                title="CONNECT TO START"
                className="ms-intro-card-swap-info-button"
              />
            </div>
          </FGridItem>
          {!isMobile ? (
            <>
              <FGridItem size={[0]}>
                <div className="ms-intro-card-swap-divider" />
              </FGridItem>
              <FGridItem
                size={[4, 4, 12]}
                className="ms-intro-card-swap-info-wrapper f-card-multiswap-secondary-m"
              >
                <p className="ms-intro-card-swap-info-heading">
                  WHAT IS MULTISWAP?
                </p>
                <p className="ms-intro-card-swap-info-text">
                  Visit our landing page for extensive information about
                  MultiSwap, including details on benefits, security features,
                  Fiber Engine, and more.
                </p>
                <p className="f-pt--2 more-info">
                  <a
                    href="https://docs.ferrumnetwork.io/ferrum-network-ecosystem/v/multiswap-and-multichain-liquidity-pool-bridge/"
                    target="_blank"
                    style={{ color: "#d9b373" }}
                  >
                    MORE INFORMATION
                  </a>
                </p>
              </FGridItem>
            </>
          ) : null}
        </FGrid>
      </FCard>
    </div>
  );
};
